import { MvpStatusCard } from "../../shared/ui/MvpStatusCard";

/** T88 — Sao lưu & khôi phục (Pro). */
export function BackupSettingsPage() {
  return (
    <MvpStatusCard
      status="pro"
      title="Sao lưu & khôi phục"
      description="Tạo và tải bản sao lưu dữ liệu phòng khám, khôi phục từ bản sao lưu trước đó."
      upcoming={[
        "Tải xuống bản sao lưu định kỳ (PostgreSQL dump + tệp đính kèm)",
        "Lịch sao lưu tự động hằng đêm",
        "Yêu cầu khôi phục dữ liệu có giám sát của đội vận hành",
      ]}
    />
  );
}
